module.exports = __webpack_public_path__ + "media/frames/frame_natural_vertical-3ab2c34c.jpg";